import React from 'react';
import {IBooking} from "./models";
import {dateFormatOptions} from "../../common/dateFormatterConfig";

interface IBookingsTableProps {
    bookingsData: Array<IBooking>;
}

export function BookingsTable(props: IBookingsTableProps) {
    if (props.bookingsData.length === 0)
        return <div className="text-center">Kirjed puuduvad</div>;

    props.bookingsData.sort(( b, a) =>
        ((a.documentDate < b.documentDate) ?
            -1 : ((a.documentDate > b.documentDate) ? 1 : 0)));
    const tableRows = props.bookingsData.map((item: IBooking) => {

       return (
           <tr key={item.remoteProductId}>
               <td>{item.documentDate ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(item.documentDate)) : ""}</td>
               <td>{item.productName}</td>
               <td>{item.quantity}</td>
               <td>{item.priceVat}</td>
               <td>{item.loadingLocationName}</td>
           </tr>
       )
    });

    return (
        <div className="table__container scroll-icon-md">
            <table className='bookings__table table table-responsive-md table-hover'>
            <thead>
            <tr>
                <th>Kuupäev</th>
                <th>Nimi</th>
                <th>Kogus</th>
                <th>Hind</th>
                <th>Asukoht</th>
            </tr>
            </thead>
            <tbody>
                {tableRows}
            </tbody>
        </table>
        </div>
    )
}
